import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { shape, string, arrayOf, func, bool, oneOfType, node } from 'prop-types';
import { getVariation } from '../../utils';
import AttributeBase from '../AttributeBase';
import AttributeRadio from '../AttributeRadio';
import WarningText from './WarningText';

const Attribute = ({
  attribute,
  variations,
  onChange,
  alignment,
  showWarningText,
  warningMessage,
  iconWarningText
}) => {
  var _attribute$values;

  return /*#__PURE__*/React.createElement(AttributeBase, _extends({}, attribute, {
    alignment: alignment
  }), attribute == null ? void 0 : (_attribute$values = attribute.values) == null ? void 0 : _attribute$values.map((value, index) => {
    const variation = getVariation(variations, value);
    return /*#__PURE__*/React.createElement(AttributeRadio, {
      key: `${value}-${index}`,
      value: value,
      type: attribute == null ? void 0 : attribute.type,
      checked: (attribute == null ? void 0 : attribute.selected) && (attribute == null ? void 0 : attribute.current) === value,
      disabled: !(variation != null && variation.isAvailable) && !(variation != null && variation.available),
      onChange: onChange
    }, value);
  }), /*#__PURE__*/React.createElement(WarningText, {
    showAlert: showWarningText,
    message: warningMessage,
    icon: iconWarningText,
    alignment: alignment
  }));
};

Attribute.defaultProps = {
  attribute: {},
  variations: [],
  alignment: '',
  showWarningText: false,
  warningMessage: '',
  iconWarningText: ''
};
process.env.NODE_ENV !== "production" ? Attribute.propTypes = {
  attribute: shape({
    label: string,
    type: string,
    current: string,
    selected: bool,
    values: arrayOf(string)
  }),
  variations: arrayOf(shape({
    image: string,
    label: string,
    type: string,
    value: string,
    id: string
  })),
  onChange: func,
  alignment: string,
  showWarningText: bool,
  warningMessage: string,
  iconWarningText: oneOfType([node, string])
} : void 0;
export default Attribute;